module.exports = __webpack_public_path__ + "static/assets/87d216851272b1e173095032e91209a9.svg";